var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'notifications-bell': true,
        hasNotif: _vm.notificationsCount > 0
    },on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'bell']}}),(_vm.notificationsCount > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.notificationsCount > 99 ? '...' : _vm.notificationsCount)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }